import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ChildProfileForm } from '../../components/auth';
import { useAuth } from '../../contexts/AuthContext';
import MigrationPrompt from '../../components/MigrationPrompt/MigrationPrompt';
import './CreateChildProfileView.css';

/**
 * View for creating a new child profile
 */
const CreateChildProfileView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { anonymousActivity } = useAuth();
  
  // State to track if profile was created and needs migration
  const [createdProfile, setCreatedProfile] = useState(null);
  const [showMigration, setShowMigration] = useState(false);
  
  // Check if we're coming from the first-run experience
  const fromFirstRun = location.state?.fromFirstRun || false;
  
  const handleSuccess = (profile) => {
    // If anonymous user has content, show migration prompt
    if (anonymousActivity && anonymousActivity.hasContent) {
      setCreatedProfile(profile);
      setShowMigration(true);
    } else {
      // No content to migrate, navigate normally
      handleNavigation();
    }
  };
  
  const handleNavigation = () => {
    // If coming from first-run, navigate to story creation flow
    // Otherwise, navigate back to the home page
    if (fromFirstRun) {
      navigate('/weaversworld/create');
    } else {
      navigate('/weaversworld');
    }
  };
  
  const handleMigrationComplete = () => {
    // After migration is complete, continue with navigation
    handleNavigation();
  };
  
  const handleCancel = () => {
    // Navigate back to the home page
    navigate('/weaversworld');
  };
  
  return (
    <div className="content-container centered-profile-form">
      <div className="create-profile-view">
        {showMigration && createdProfile ? (
          <MigrationPrompt 
            childProfile={createdProfile}
            onComplete={handleMigrationComplete}
          />
        ) : (
          <ChildProfileForm 
            onSuccess={handleSuccess}
            onCancel={handleCancel}
          />
        )}
      </div>
    </div>
  );
};

export default CreateChildProfileView;